import { createContext } from "react";

export type MeasurementsContextType = [
  undefined,
  {
    deleteById(id: string): Promise<{ id: string } | undefined>;
    deleteVideo(id: string): Promise<void>;
    updateCompletedDate(id: string, completedDate: string): Promise<void>;
  },
];

const MeasurementsContext = createContext<MeasurementsContextType | undefined>(undefined);

export default MeasurementsContext;
